/**
 * User - what is returned as part of add practice record response.
 */
export default class User {
  totalPoints: string;
  totalTime: string;
  level: number;
  nextLevel: number;
  didLevelUp: boolean;
  pointsUntilNextLevel: number;
  pointsAlreadyEarnedTowardNextLevel: number;
  constructor({ totalTime, totalPoints, level, nextLevel, didLevelUp, pointsUntilNextLevel, pointsAlreadyEarnedTowardNextLevel, }: User) {
    Object.assign(this, { totalPoints, totalTime, level, nextLevel, didLevelUp, pointsUntilNextLevel, pointsAlreadyEarnedTowardNextLevel, });
  }
}